import React from "react";
import logo from "../assests/logo.png";
import HubspotForm from "react-hubspot-form";

const today = new Date();

const Footer = () => {

  return (
    <>
      <section id="contact" className="startup-contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="row">
                <div className="col-12 text-center">
                  <h1 className="text-white">
                    Get Quote & Start Your Office Space Journey Today!
                  </h1>
                  <p
                    className="h2 text-white"
                    style={{ fontSize: "25px", marginTop: "15px" }}
                  >
                    Unlock a new level of productivity, creativity, and success
                    with Premisin. Your journey towards a brighter workspace
                    future begins here!
                  </p>

                  <div className="u-h-4 u-w-50 bg-white rounded mt-4 u-mb-50 mx-auto"></div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 text-center">
                  <div className="mb-4 p-4 p-md-5 bg-white rounded u-of-hidden">
                    <div style={{ marginBottom: '-80px' }}>
                      <HubspotForm
                        portalId='7848680'
                        formId='5f122df2-e3ea-42b4-b86f-628bdf7cfed3'
                        onSubmit={() => console.log('Submit!')}
                        onReady={(form) => console.log('Form ready!')}
                        loading={<div>Loading...</div>}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer-startup">
        <section className="bg-gray-v2">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-5 mb-lg-0">
                <img src={logo} alt="Premisin" />
                <p className="u-mt-40 mb-0">
                  We believe in revolutionizing your space just the way you
                  want, liberating our reach to your comfort. Premisin offers
                  facilities that are spacious, accessible and comfortable for
                  the benefit of our society.
                </p>
              </div>
              <div className="col-lg-3 col-md-6 ml-auto mb-5 mb-lg-0">
                <h4>Contact Info</h4>
                <div className="u-h-4 u-w-50 bg-primary rounded mt-3 u-mb-40"></div>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <span className="icon icon-Phone2 text-primary mr-1">
                      <i className="fa fa-phone  text-primary mr-1 pt-1"></i>
                    </span>
                    <a
                      onClick={() => {
                        window.gtag_report_conversion('tel:7583837701');
                      }}
                      href="tel:7583837701"
                    >
                      758383 7701
                    </a>
                  </li>
                  <li className="mb-2">
                    <span class="icon icon-Mail text-primary mr-1">
                      <i
                        className="fa fa-envelope text-primary mr-1 pt-1"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <a
                      // onclick="called_phone_gads_track();"
                      onClick={() => {
                        window.gtag_report_conversion('mailto:info@premisin.com');
                      }}
                      href="mailto:info@premisin.com"
                      fa
                      fa-map-marker
                    >
                      info@premisin.com
                    </a>
                  </li>
                  <li className="mb-0">
                    <span className="icon icon-Pointer text-primary mr-2">
                      <i
                        className="fa fa-map-marker text-primary mr-1 pt-1"
                        aria-hidden="true"
                      ></i>
                    </span>
                    C-240/245/246, Vallabh Nagar, Near St. Gyaneshawar School
                    Raipur, Chhattisgarh- 492001
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 ml-auto mb-0 mb-lg-0">
                <h4>Connect With Us</h4>
                <div className="u-h-4 u-w-50 bg-primary rounded mt-3 u-mb-40"></div>
                <ul className="list-inline social social-rounded social-white mt-4 mb-0">
                  <li className="list-inline-item">
                    <a
                      onClick={() => {
                        window.gtag_report_conversion('https://www.facebook.com/premisin/');
                      }}
                      rel="noreferrer"
                      href="https://www.facebook.com/premisin/"
                      target="_blank"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      onClick={() => {
                        window.gtag_report_conversion('tel:7583837701');
                      }}
                      href="https://twitter.com/premisin/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      onClick={() => {
                        window.gtag_report_conversion('https://www.instagram.com/premisinraipur');
                      }}
                      rel="noreferrer"
                      href="https://www.instagram.com/premisinraipur"
                      target="_blank"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      onClick={() => {
                        window.gtag_report_conversion('https://www.linkedin.com/in/premisin/');
                      }}
                      rel="noreferrer"
                      href="https://www.linkedin.com/in/premisin/"
                      target="_blank"
                    >
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="u-py-20">
          <div className="container">
            <p className="mb-0 text-center">
              Premisin &copy; {today.getFullYear()} - All Rights Reserved.
            </p>
          </div>
        </section>
      </footer>

      <div className="call-nav  box-shadow-v2" style={{ bottom: '180px' }}>
        <a
          target="_BLANK"
          rel="noreferrer"
          href="https://api.whatsapp.com/send?phone=+917583837701&text=Hello,%20Sending%20you%20message%20from%20https://landing.premisin.com/"
        >
          <i className="fa fa-whatsapp text-white" aria-hidden="true"></i>
          <span className="d-none">7583837701</span>
        </a>
      </div>

      <div className="call-nav  box-shadow-v2" style={{ backgroundColor: 'black' }}>
        <a
          onClick={() => {
            window.gtag("event", "bottom_button_click_call");
            window.gtag_report_conversion('tel:7583837701');
          }}
          href="tel:7583837701"
        >
          <i className="fa fa-phone text-white" aria-hidden="true"></i>
          <span className="d-none">7583837701</span>
        </a>
      </div>

      <div className="email-nav  box-shadow-v2">
        <a
          href="/"
          data-toggle="modal"
          data-target="#sidenavmail"
          onClick={(e) => {
            e.preventDefault()
            window.gtag("event", "side_ouroffice_button_click_enuire_now");
          }}
        >
          <i className="fa fa-envelope text-white" aria-hidden="true"></i>
        </a>
      </div>
    </>
  );
};

export default Footer;
